module.exports = __webpack_public_path__ + "img/history_ins_detail.0fc76f36.png";